import { z } from "zod";
import { PartnerSchema } from "../schemas";

/** Complete editable record. Null/omitted optional facts mean explicitly cleared. */
export const PartnerRecordDataSchema = PartnerSchema.omit({
  id: true,
  tenantId: true,
  createdAt: true,
  updatedAt: true,
})
  .extend({
    contactEmail: PartnerSchema.shape.contactEmail.nullable(),
    address: PartnerSchema.shape.address.nullable(),
    taxIds: PartnerSchema.shape.taxIds.nullable(),
    networkIds: PartnerSchema.shape.networkIds.nullable(),
    bankDetails: PartnerSchema.shape.bankDetails.nullable(),
    paymentTerms: PartnerSchema.shape.paymentTerms.nullable(),
    contactPerson: PartnerSchema.shape.contactPerson.nullable(),
    customerNumber: PartnerSchema.shape.customerNumber.nullable(),
    supplierNumber: PartnerSchema.shape.supplierNumber.nullable(),
  })
  .strict();

export const PartnerRecordSaveSchema = z
  .object({
    data: PartnerRecordDataSchema,
    expectedUpdatedAt: z.string().datetime({ offset: true }),
  })
  .strict();
export type PartnerRecordData = z.infer<typeof PartnerRecordDataSchema>;
